// eslint-disable-next-line no-magic-numbers
const MAP_INITAL_CENTER = [0.2, 0.25];

export default {MAP_INITAL_CENTER};
